import { getCraftLetter } from "@/utils/craftLetter";
import { Box } from "@mui/material";

type Props = {
	name: string | null | undefined;
	code: string | null | undefined;
	color: string | null | undefined;
};

// Same size as the craft badge in the Work Orders and Templates grids. The letter box is
// trimmed to cap height so the glyph itself is centred, not its line box.
export const CraftLetterBadge = ({ name, code, color }: Props) => (
	<Box
		sx={{
			height: 26,
			width: 26,
			minWidth: 26,
			borderRadius: "4px",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			background: color || "#FFFFFF",
			color: "#FFF",
			fontWeight: 600,
		}}
	>
		<Box
			component="span"
			sx={{
				display: "block",
				lineHeight: 1,
				textBoxTrim: "trim-both",
				textBoxEdge: "cap alphabetic",
			}}
		>
			{getCraftLetter(name, code)}
		</Box>
	</Box>
);
